export default __webpack_public_path__ + "static/media/logo.c9a16c8a.png";